import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, input, Signal, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';

import {
    IonSegment,
    IonSegmentButton,
    IonSegmentContent,
    IonSegmentView,
    SegmentCustomEvent
} from '@ionic/angular/standalone';

import { ReviewItemComponent } from '../../../components/review-item/review-item.component';
import { FormatFirstNameLastLetterPipe } from '../../../pipes';
import { ProUserService } from '../../../services';
import { GuardApiInterface, ProInterface, ProSchedule } from '../../../types';
import { UserProfileComponent } from '../user-profile/user-profile.component';

@Component({
    selector: 'lib-guard-user-profile',
    imports: [
        CommonModule,
        UserProfileComponent,
        IonSegment,
        IonSegmentButton,
        IonSegmentContent,
        IonSegmentView,
        ReviewItemComponent,
        FormatFirstNameLastLetterPipe
    ],
    templateUrl: './guard-user-profile.component.html',
    styleUrl: './guard-user-profile.component.css'
})
export class GuardUserProfileComponent {
    /* eslint-disable */
    viewingAs = input<'self' | 'other' | null>(null);
    user = input<(ProInterface | GuardApiInterface) | null>(null);

    router = inject(Router);
    proUserService = inject(ProUserService);

    guardInfo: Signal<any> = computed(() => {
        return this.user() || this.proUserService.user() || null;
    });

    segmentSelected: WritableSignal<'about' | 'availability' | 'reviews' | string | number | undefined> =
        signal('about');

    userSchedule: WritableSignal<ProSchedule | null> = signal(this.proUserService.user()?.schedule || null);

    weekdayMorning: WritableSignal<boolean> = signal(false);
    weekdayEvening: WritableSignal<boolean> = signal(false);
    weekdayOvernight: WritableSignal<boolean> = signal(false);

    weekendMorning: WritableSignal<boolean> = signal(false);
    weekendEvening: WritableSignal<boolean> = signal(false);
    weekendOvernight: WritableSignal<boolean> = signal(false);

    constructor() {
        effect(() => {
            const userSchedule = this.user()?.schedule || this.proUserService.user()?.schedule;

            this.weekdayMorning.set(
                userSchedule?.monday_morning === 1 ||
                    userSchedule?.tuesday_morning === 1 ||
                    userSchedule?.wednesday_morning === 1 ||
                    userSchedule?.thursday_morning === 1 ||
                    userSchedule?.friday_morning === 1
            );

            this.weekdayEvening.set(
                userSchedule?.monday_evening === 1 ||
                    userSchedule?.tuesday_evening === 1 ||
                    userSchedule?.wednesday_evening === 1 ||
                    userSchedule?.thursday_evening === 1 ||
                    userSchedule?.friday_evening === 1
            );

            this.weekdayOvernight.set(
                userSchedule?.monday_overnight === 1 ||
                    userSchedule?.tuesday_overnight === 1 ||
                    userSchedule?.wednesday_overnight === 1 ||
                    userSchedule?.thursday_overnight === 1 ||
                    userSchedule?.friday_overnight === 1
            );

            this.weekendMorning.set(userSchedule?.saturday_morning === 1 || userSchedule?.sunday_morning === 1);

            this.weekendEvening.set(userSchedule?.saturday_evening === 1 || userSchedule?.sunday_evening === 1);

            this.weekendOvernight.set(userSchedule?.saturday_overnight === 1 || userSchedule?.sunday_overnight === 1);
        });
    }

    segmentChange(event: SegmentCustomEvent) {
        this.segmentSelected.set(event.detail.value);
    }

    goTo(path: string) {
        this.router.navigateByUrl(path);
    }
}
